import { monitorForElements } from "@atlaskit/pragmatic-drag-and-drop/element/adapter";
import { useEffect, useState } from "react";
import type { DraggableItem } from "./types";

interface DndMonitorProps {
	onDragStart?: () => void;
}

interface DndMonitorState {
	isDragging: boolean;
	isOver: boolean;
	dragType: DraggableItem | null;
	dragItem: unknown;
}

const IDLE: DndMonitorState = {
	isDragging: false,
	isOver: false,
	dragType: null,
	dragItem: null,
};

export function useDndMonitor(props?: DndMonitorProps) {
	/** State */
	const [state, setState] = useState<DndMonitorState>(IDLE);

	/** Effects */
	useEffect(() => {
		return monitorForElements({
			onDragStart({ source }) {
				props?.onDragStart?.();
				setState({
					isDragging: true,
					isOver: false,
					dragType: source.data.type as DraggableItem,
					dragItem: source.data.item,
				});
			},
			onDropTargetChange({ location }) {
				setState((prev) => ({
					...prev,
					isOver: location.current.dropTargets.length > 0,
				}));
			},
			onDrop() {
				setState(IDLE);
			},
		});
	}, []);

	/** Return */
	return state;
}
